export default __webpack_public_path__ + "static/solar_titan-1a7bff.svg";